/* ================================================== *\
 * Model to store SVG polygon and paths from a residence.
\* ================================================== */

import { Model } from '@vuex-orm/core';
import Availability from '@/models/Availability';

export default class Shape extends Model {
  static entity = 'shapes';

  static fields() {
    return {
      id: this.uid(),

      illustration: this.attr(null),
      polygon: this.attr(null),
      path: this.attr(null),

      type: this.attr(null),
      url: this.attr(null),

      // Relationship
      availability_id: this.attr(null),
      availability: this.belongsTo(Availability, 'availability_id'),
      shapeable_id: this.attr(null),
      shapeable_type: this.attr(null),
      shapeable: this.morphTo('shapeable_id', 'shapeable_type'),
    };
  }
}
